// extracted by mini-css-extract-plugin
export default {"mainContainer":"Breadcrumb_mainContainer__8PDdY","pageName":"Breadcrumb_pageName__sOcCa","currentName":"Breadcrumb_currentName__vdjIt"};